import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import {CircularProgress} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const InvoicePreview = (props) => {
  const classes = useStyles();
  const {open, setOpen, loading, setLoading, url, setUrl, saveInvoice, invoiceId} = props;

  const handleSave= () => {
    saveInvoice(invoiceId);
    setOpen(false);
  };

  const handleClose= () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              Invoice Preview
            </Typography>
            <Button autoFocus color="inherit" onClick={handleSave}>
              Save This Invoice and Push To Job
            </Button>
          </Toolbar>
        </AppBar>
        {loading && <div style={{textAlign: "center"}}> <CircularProgress/> <br /><br /> Generating Invoice Preview... </div>}
        {!loading && <iframe height="100%" width="100%" src={url}></iframe>}
      </Dialog>
    </div>
  );
}

export default InvoicePreview;